import { Facebook, Instagram } from "lucide-react";

import { useTranslation } from 'react-i18next';

const Footer = () => {
    const { t } = useTranslation();

    return (
        <footer className="w-full bg-white border-t pt-12 pb-6" id="footer">

            {/* Top Section */}
            <div className="w-full max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-24 px-4 lg:px-0">
                {/* Left column: Brand + About + Socials */}
                <div className="space-y-6">
                    <div>
                        <div className="flex items-center gap-3 mb-4">
                            {/* <div className="w-10 h-10 bg-lime-700 rounded-lg flex items-center justify-center">
                                <span className="text-white font-bold text-xl">M</span>
                            </div> */}
                            <span className="text-4xl font-bold tracking-tight">
                                Meets<span className="text-lime-700">&</span>Works
                            </span>
                        </div>

                        <p className="text-gray-500 text-sm leading-relaxed max-w-sm mb-6">
                            {t('footer.description')}
                        </p>
                    </div>

                    <div>
                        <h3 className="font-semibold text-gray-900 mb-3">{t('footer.followUs')}</h3>
                        <div className="flex items-center gap-4">
                            <a
                                href="https://www.facebook.com/profile.php?id=61585631663926"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-lime-700 hover:text-gray-900 transition-colors"
                                aria-label="meetsNworks on Facebook"
                            >
                                <Facebook size={20} />
                            </a>
                            <a
                                href="https://www.instagram.com/meets_n_works?igsh=azg5ejg4NGxrdHhs"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-lime-700 hover:text-gray-900 transition-colors"
                                aria-label="meetsNworks on Instagram"
                            >
                                <Instagram size={20} />
                            </a>
                            <a
                                href="https://wa.me/255796973433?text=Hello%2C%20meetsNworks.%20I%20need%20help%20with%20my%20booking."
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-lime-700 hover:text-gray-900 transition-colors"
                                aria-label="meetsNworks on WhatsApp"
                            >
                                <svg
                                    width="30"
                                    height="30"
                                    viewBox="0 0 32 32"
                                    fill="currentColor"
                                    aria-hidden="true"
                                >
                                    <path d="M19.11 17.47c-.28-.14-1.65-.81-1.9-.9-.26-.1-.45-.14-.64.14-.19.28-.74.9-.9 1.08-.17.19-.33.21-.61.07-.28-.14-1.18-.43-2.24-1.39-.83-.74-1.39-1.66-1.55-1.94-.16-.28-.02-.43.12-.57.12-.12.28-.33.43-.5.14-.16.19-.28.28-.47.09-.19.05-.36-.02-.5-.07-.14-.64-1.54-.88-2.1-.23-.55-.47-.47-.64-.48-.17-.01-.36-.01-.55-.01-.19 0-.5.07-.76.36-.26.28-1 1-1 2.43 0 1.43 1.02 2.81 1.16 3 .14.19 2 3.05 4.86 4.28.68.29 1.21.46 1.62.59.68.22 1.29.19 1.77.12.54-.08 1.65-.68 1.88-1.33.23-.66.23-1.23.16-1.33-.07-.11-.26-.17-.54-.31zM16.02 4.8c-6.13 0-11.11 4.99-11.11 11.12 0 1.96.51 3.88 1.48 5.58L4.8 27.2l5.86-1.54a11.1 11.1 0 005.36 1.38c6.13 0 11.12-4.99 11.12-11.12 0-6.13-4.99-11.12-11.12-11.12zm0 20.38a9.2 9.2 0 01-4.72-1.3l-.34-.2-3.48.92.93-3.39-.22-.35a9.15 9.15 0 01-1.37-4.89c0-5.05 4.12-9.17 9.2-9.17 5.07 0 9.19 4.12 9.19 9.17 0 5.07-4.12 9.21-9.19 9.21z" />
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>

                {/* Right column: Links */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8 text-sm">
                    <div>
                        <h3 className="font-semibold text-gray-900 mb-4">{t('footer.explore.title')}</h3>
                        <ul className="space-y-3 text-gray-600">
                            <li><a href="/spaces" className="hover:text-lime-700">{t('footer.explore.spaces')}</a></li>
                            <li><a href="#how-it-works" className="hover:text-lime-700">{t('footer.explore.howItWorks')}</a></li>
                            <li><a href="#about" className="hover:text-lime-700">{t('footer.explore.about')}</a></li>
                            <li>
                                <a
                                    href="https://wa.me/255796973433?text=Hello%2C%20meetsNworks.%20I%20need%20support%20with%20my%20workspace%20booking."
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="hover:text-lime-700"
                                >
                                    {t('footer.explore.help')}
                                </a>
                            </li>
                            <li><a href="#faqs" className="hover:text-lime-700">{t('footer.explore.faqs')}</a></li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="font-semibold text-gray-900 mb-4">{t('footer.contact.title')}</h3>
                        <ul className="space-y-3 text-sm text-gray-600">
                            <li className="leading-relaxed hover:text-lime-700">
                                <a
                                    href="https://www.google.com/maps/place/PSSSF+COMMERCIAL+COMPLEX/data=!4m2!3m1!1s0x0:0xa57f6ec7db3aa101?sa=X&ved=1t:2428&ictx=111"
                                    className="hover:text-lime-700"
                                >
                                    {t('footer.contact.address')}
                                </a>
                            </li>
                            <li>
                                <a
                                    href="mailto:info@meetsnworks.com"
                                    className="hover:text-lime-700"
                                >
                                    info@meetsnworks.com
                                </a>
                            </li>

                            <li>
                                <a href="tel:+255690260059" className="hover:text-lime-700">
                                    +255 690 260 059
                                </a>
                            </li>
                            <li>
                                <a href="tel:+255796973433" className="hover:text-lime-700">
                                    +255 796 973 433
                                </a>
                            </li>
                        </ul>
                    </div>

                </div>
            </div>


            {/* Divider */}
            <div className="w-full max-w-6xl mx-auto border-t mt-10 pt-4 flex flex-col lg:flex-row justify-between text-sm text-gray-500 px-4 lg:px-0">
                <p>{t('footer.copyright', { year: new Date().getFullYear() })}</p>
                <p className="mt-2 lg:mt-0">{t('footer.builtWith')}</p>
            </div>
        </footer>
    );
};

export default Footer;
